module.exports = __webpack_public_path__ + "assets/img/thumb-DB-Results-2-Service-Page.d823fa22.jpg";